import { gql } from 'react-apollo';

export default gql`
  query allOffers($query: QueryInput!) {
    allOffers(query: $query) {
      _id
      items {
        _id
        status
        locationsToExclude
        disclaimerText
        tombstoneImageUrl
        listingType
        repName
        crdNumber
        investmentInstrument
        area
        sector
        typeOfOffer
        minimumInvestment
        offerPassword
        headerType
        headerVideoId
        offerPresentationTitle
        offerPresentationUrl
        enableOfferPresentation
        stripeAccountId
        stripeProductId
        targetRaise
        offerCurrency
        valueRange
        assetStatus
        sharesForSale
        primaryObjective
        netAcres
        county
        averageDailyProduction
        baseCurrency
        geographicMandate
        fundType
        domicileOption
        domicileOnshore
        domicileOnshoreFund_other
        domicileOffShore
        domicileOffShore_other
        systematicDiscretionaryOption
        investmentCoActExemptionOption
        investmentAdvisorType
        leverage
        fundStructure
        fundStrategyClassfication
        fundStrategyClassficationOne
        fundStrategyClassficationTwo
        fundStrategyClassficationThree
        aumfund
        fundCapacity
        trackRecordFund
        trackRecordFirm
        openedAt
        tenantId
        toggleDataRoom
        altOfferTitle
        productDeveloper
        creditIssued
        product
        vintage
        region
        hideSubFields
        bypassDocusign
        closingDate
        tenant {
          _id
          name
          domainPrefix
          customDomain
        }
        sharedTenants {
          tenantId
          published
        }
        issuerCompany {
          _id
          name
          isCompanyApproved
          users {
            _id
            isManagementUserApproved
          }
        }
        investorOffer {
          _id
          favorited
        }
        isVanityUrl
        vanityUrl
      }
      total
    }
  }
`;



// WEBPACK FOOTER //
// ./src/apollo/queries/allOffers.js